import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const router = new Router({
  scrollBehavior(to,from,savePosition){
    return{x:0,y:0}//滚动到顶部
  },
  routes: [
    {path: "/", redirect: '/login'},
  {
    path: '/login/:activityId',
    name: 'login',
    meta:{
      title:'抽奖活动',
    },
    component: resolve=>require(['../views/login/index.vue'],resolve),
    },
  {
    path: '/login',
    name: 'login',
    meta:{
      title:'抽奖活动',
    },
    component: resolve=>require(['../views/login/index.vue'],resolve),
    },
 {
      path: '/noActivity',
      name: 'noActivity',
      meta:{
        title:'未找到活动',
      },
      component: resolve=>require(['../views/noActivity/index.vue'],resolve),
  },{
      path: '/overDue',
      name: 'overDue',
      meta:{
        title:'活动状态异常',
      },
      component: resolve=>require(['../views/overDue/index.vue'],resolve),
  },
  {
      path: '/installmentCouponInfo',
      name: 'installmentCouponInfo',
      meta:{
        title:'分期优惠券详情',
      },
      component: resolve=>require(['../views/installmentCouponInfo/installmentCouponInfo.vue'],resolve),
  },
  ]
});
export {
  router
}



// WEBPACK FOOTER //
// ./src/router/index.js